import React from 'react';
import './HowItWorks.css';
import { Link } from 'react-router-dom';

function HowItWorks () {
    return (
        <div className='how-it-works-container' id='howitworks'>
            <div className='how-it-works-inner-container'>
                <h4 style={{ fontWeight: "700", color: "grey" }}>How It Works</h4>
                <h1 style={{ fontWeight: "700" }}>We Follow Step By Step Process</h1>
                <div className='how-it-works-content-container'>
                    <div className='how-it-works-content-image'>
                        <img src={require( "../../images/how-it-works/image1.png" )} alt="" />
                    </div>
                    <div className='how-it-works-content'>
                        <span>
                            1
                        </span>
                        <div className='how-it-works-content-text'>
                            <h4>Pick Up</h4>
                            <div className='how-it-works-content-text-content'>
                                Book a pick up through phone call or <Link to="/pricing" style={{ color: "black" }}>ordering online</Link>. We pick up and deliver at convenient times for you – that includes late evenings and weekends, helping you to get the best out of our service.
                            </div>
                        </div>
                    </div>
                </div>
                <div className='how-it-works-content-container'>
                    <div className='how-it-works-content-image'>
                        <img src={require( "../../images/how-it-works/image2.png" )} alt="" />
                    </div>
                    <div className='how-it-works-content'>
                        <span>
                            2
                        </span>
                        <div className='how-it-works-content-text'>
                            <h4>Handoff for Wash</h4>
                            <div className='how-it-works-content-text-content'>
                                We bring personalized bags to put all your clothes for washing, ironing and dry cleaning. Our scout will ask you a few questions and take note of your preferences. That is it. We will handle it from here.
                            </div>
                        </div>
                    </div>
                </div>
                <div className='how-it-works-content-container'>
                    <div className='how-it-works-content-image'>
                        <img src={require( "../../images/how-it-works/image3.png" )} alt="" />
                    </div>
                    <div className='how-it-works-content'>
                        <span>
                            3
                        </span>
                        <div className='how-it-works-content-text'>
                            <h4>Magic</h4>
                            <div className='how-it-works-content-text-content'>
                                Our expert cleaners do their best to make your clothes look great and feel fresh. We separate by color or wash it mixed, depending on what you requested. Once it’s done, we fold it and pack it neatly.
                            </div>
                        </div>
                    </div>
                </div>
                <div className='how-it-works-content-container'>
                    <div className='how-it-works-content-image'>
                        <img src={require( "../../images/how-it-works/image4.png" )} alt="" />
                    </div>
                    <div className='how-it-works-content'>
                        <span>
                            4
                        </span>
                        <div className='how-it-works-content-text'>
                            <h4>Enjoy Clean Clothes</h4>
                            <div className='how-it-works-content-text-content'>
                                Within 48-72 hours, our scout delivers your laundry fresh and ready for action.
                            </div>
                        </div>
                    </div>
                </div>
                <swiper-container autoplay loop={true} autoplay-delay={6000} slides-per-view={1} space-between={40} pagination={true}>
                    <swiper-slide className='how-it-works-content-container'>
                        <div className='how-it-works-content-image'>
                            <img src={require( "../../images/how-it-works/image1.png" )} alt="" />
                        </div>
                        <div className='how-it-works-content'>
                            <span>
                                1
                            </span>
                            <div className='how-it-works-content-text'>
                                <h4>Pick Up</h4>
                                <div className='how-it-works-content-text-content'>
                                    Book a pick up through <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer">app</a> or <Link to="/pricing" style={{ color: "black" }}>website</Link>. We pick up and deliver at convenient times for you – that includes late evenings and weekends, helping you to get the best out of our service.
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide className='how-it-works-content-container'>
                        <div className='how-it-works-content-image'>
                            <img src={require( "../../images/how-it-works/image2.png" )} alt="" />
                        </div>
                        <div className='how-it-works-content'>
                            <span>
                                2
                            </span>
                            <div className='how-it-works-content-text'>
                                <h4>Handoff for Wash</h4>
                                <div className='how-it-works-content-text-content'>
                                    We bring personalized bags to put all your clothes for washing, ironing and dry cleaning. Our scout will ask you a few questions and take note of your preferences. That is it. We will handle it from here.
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide className='how-it-works-content-container'>
                        <div className='how-it-works-content-image'>
                            <img src={require( "../../images/how-it-works/image3.png" )} alt="" />
                        </div>
                        <div className='how-it-works-content'>
                            <span>
                                3
                            </span>
                            <div className='how-it-works-content-text'>
                                <h4>Magic</h4>
                                <div className='how-it-works-content-text-content'>
                                    Our expert cleaners do their best to make your clothes look great and feel fresh. We separate by color or wash it mixed, depending on what you requested. Once it’s done, we fold it and pack it neatly.
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                    <swiper-slide className='how-it-works-content-container'>
                        <div className='how-it-works-content-image'>
                            <img src={require( "../../images/how-it-works/image4.png" )} alt="" />
                        </div>
                        <div className='how-it-works-content'>
                            <span>
                                4
                            </span>
                            <div className='how-it-works-content-text'>
                                <h4>Enjoy Clean Clothes</h4>
                                <div className='how-it-works-content-text-content'>
                                    Within 48-72 hours, our scout delivers your laundry fresh and ready for action.
                                </div>
                            </div>
                        </div>
                    </swiper-slide>
                </swiper-container>
            </div>
        </div>
    )
}

export default HowItWorks